import { Button, Tooltip } from '@nextui-org/react';
import React, { FC, SetStateAction, useEffect, useState } from 'react';
import { FaSignOutAlt } from 'react-icons/fa';
import { FaBoxesPacking } from 'react-icons/fa6';
import { useLocation, useNavigate } from 'react-router-dom';

import { logOut } from '../../redux/features/generalData/generalDataSlice';
import { useAsyncDispatch } from '../../redux/store';

export interface SideMenuOption {
  icon: JSX.Element;
  name: string;
  path: string;
}

export interface SideMenuProps {
  isOpen: boolean;
  setMenuColapsed: React.Dispatch<SetStateAction<boolean>>;
}

const SideMenuMobile: FC<SideMenuProps> = ({
  isOpen,
  setMenuColapsed,
}): JSX.Element => {
  const navigate = useNavigate();
  const dispatch = useAsyncDispatch();
  const { pathname } = useLocation();
  const [selectedMenuButton, setSelectedMenuButton] = useState<string>('');
  const menus: SideMenuOption[] = [
    {
      icon: <FaBoxesPacking className="h-6 w-12" />,
      name: 'Etiquetar',
      path: '/Etiquetar',
    },
  ];

  useEffect(() => {
    const menu = menus.find(({ path }) => pathname.includes(path));
    setSelectedMenuButton(menu?.name ?? '');
  }, [pathname]);

  return (
    <div
      style={
        isOpen
          ? {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
            }
          : {}
      }
      className={`mt-8 w-full overflow-hidden transition-[display] duration-250 ${
        isOpen ? 'block' : 'hidden'
      }`}
    >
      <div>
        {menus.map((menu) => (
          <Tooltip
            key={menu.name}
            showArrow
            placement="right"
            color="foreground"
            content={menu.name}
            isDisabled={isOpen}
            className="rounded px-12 py-2"
            offset={-12}
          >
            <Button
              variant={selectedMenuButton === menu.name ? 'solid' : 'ghost'}
              onPress={() => {
                navigate(menu.path);
                setMenuColapsed(true);
              }}
              className="group flex w-full flex-row items-center justify-start gap-4 rounded-none border-none px-5 py-8"
            >
              <div
                className={`text-foreground-400 group-hover:text-foreground-800 ${
                  selectedMenuButton === menu.name ? 'text-foreground-800' : ''
                }`}
              >
                {menu.icon}
              </div>

              <p
                className={`font-semibold text-foreground-400 transition-opacity group-hover:text-foreground-800 ${
                  selectedMenuButton === menu.name ? 'text-foreground-800' : ''
                } ${isOpen ? 'opacity-100' : 'opacity-0'}`}
              >
                {menu.name}
              </p>
            </Button>
          </Tooltip>
        ))}
      </div>
      <Button
        variant={selectedMenuButton === 'SignOut' ? 'solid' : 'ghost'}
        onPress={() => dispatch(logOut())}
        className="group flex w-full flex-row items-center justify-start gap-4 rounded-none border-none px-5 py-8"
      >
        <div
          className={`text-foreground-400 group-hover:text-foreground-800 ${
            selectedMenuButton === 'SignOut' ? 'text-foreground-800' : ''
          }`}
        >
          <FaSignOutAlt size={20} />
        </div>

        <p
          className={`font-semibold text-foreground-400 transition-opacity group-hover:text-foreground-800 ${
            selectedMenuButton === 'SignOut' ? 'text-foreground-800' : ''
          } ${isOpen ? 'opacity-100' : 'opacity-0'}`}
        >
          LogOut
        </p>
      </Button>
    </div>
  );
};

export default SideMenuMobile;
